import React from 'react';

const STATUS_STAGES = [
    { key: 'pending', label: 'Order Placed', statuses: ['Pending', 'Awaiting Bill', 'Payment Verification Pending'] },
    { key: 'processing', label: 'Processing', statuses: ['Processing'] },
    { key: 'shipped', label: 'Out for Delivery', statuses: ['Out for Delivery'] },
    { key: 'delivered', label: 'Delivered', statuses: ['Delivered'] }
];

const OrderTimeline = ({ currentStatus }) => {
    // Handle Cancelled separately
    if (currentStatus === 'Cancelled') {
        return (
            <div className="bg-red-50 border border-red-200 rounded-xl p-4 flex items-center justify-center gap-3">
                <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                    <i className="fas fa-times text-red-500 text-lg"></i>
                </div>
                <div>
                    <p className="font-bold text-red-700">Order Cancelled</p>
                    <p className="text-xs text-red-600">This order has been cancelled.</p>
                </div>
            </div>
        );
    }

    // Determine current step index
    let currentStepIndex = 0;
    for (let i = 0; i < STATUS_STAGES.length; i++) {
        if (STATUS_STAGES[i].statuses.includes(currentStatus)) {
            currentStepIndex = i;
            break;
        }
    }
    
    // If it's a known status but didn't match, maybe default to 0.
    // E.g. 'Pending' will be index 0. 'Out for Delivery' will be index 2.

    return (
        <div className="py-6 w-full">
            <div className="relative">
                {/* Background line */}
                <div className="absolute top-1/2 left-0 w-full h-1 bg-slate-200 -translate-y-1/2 z-0 rounded-full"></div>
                
                {/* Active line */}
                <div 
                    className="absolute top-1/2 left-0 h-1 bg-sky-500 -translate-y-1/2 z-0 rounded-full transition-all duration-500" 
                    style={{ width: `${(currentStepIndex / (STATUS_STAGES.length - 1)) * 100}%` }}
                ></div>

                {/* Steps */}
                <div className="relative z-10 flex justify-between">
                    {STATUS_STAGES.map((stage, index) => {
                        const isCompleted = index <= currentStepIndex;
                        const isCurrent = index === currentStepIndex;

                        return (
                            <div key={stage.key} className="flex flex-col items-center">
                                {/* Circle */}
                                <div className={`w-8 h-8 rounded-full flex items-center justify-center border-4 transition-all duration-300 ${
                                    isCompleted 
                                        ? 'bg-sky-500 border-white shadow-[0_0_0_4px_rgba(14,165,233,0.2)]' 
                                        : 'bg-slate-200 border-white'
                                }`}>
                                    {isCompleted && <i className="fas fa-check text-white text-[10px]"></i>}
                                </div>
                                
                                {/* Label */}
                                <div className={`mt-3 text-center ${isCurrent ? 'scale-110 origin-top' : ''} transition-transform`}>
                                    <p className={`text-xs font-bold ${isCompleted ? 'text-sky-700' : 'text-slate-400'}`}>
                                        {stage.label}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            
            {/* Status explanation */}
            <div className="mt-8 bg-sky-50 border border-sky-100 rounded-xl p-4 text-center shadow-sm">
                <p className="font-bold text-sky-800 text-sm">
                    {currentStatus === 'Awaiting Bill' && "We are reviewing your prescription/custom items to generate a bill."}
                    {currentStatus === 'Payment Verification Pending' && "Awaiting your payment. Please complete payment to process the order."}
                    {currentStatus === 'Pending' && "Your order has been placed successfully."}
                    {currentStatus === 'Processing' && "We are packing your order."}
                    {currentStatus === 'Out for Delivery' && "Your order is on the way!"}
                    {currentStatus === 'Delivered' && "Order delivered successfully. Thank you for shopping with QwickMed!"}
                </p>
            </div>
        </div>
    );
};

export default OrderTimeline;
